import axios from '@/http/axios/index.js'


export default {
    getBankAccounts(payload) {
        return axios.get('hsbc/bank-accounts', { params: payload }).then(res => res.data)
    },
    getReports(payload) {
        return axios.get('hsbc/reports', { params: payload }).then(res => res.data)
    },
    getReportTransactions(payload) {
        return axios.get('hsbc/report/transactions', { params: payload }).then(res => res.data)
    },
    
}